import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CostActions } from '../models/cost-action.model';

@Injectable({
    providedIn: 'root'
})
export class ApprovalPathService {
    private url = environment.url;

    constructor(private http: HttpClient) { }


    changeApprovalPathStatus(notes: string, id: number, action: CostActions) {
        return this.http.post(`${this.url}approvalPath/${id}/action`, { action, notes });
    }

}
